import React, { useState } from "react";
import Navbar from "../components/nabvar/NavBar";
import { Box } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useSelector } from "react-redux";
import LogoutSpinner from "../components/modals/LogoutSpinner";
import { useThemes } from "../components/Theme/theme";
import { LayoutAlerts } from "../components/LayoutAlert/LayoutAlert";
import useZoomWarningPopup from "../hooks/zoomwarningpopup";
import { FloatingChatWidget } from "../features/ChatBot";
import { isAllowedChatUser } from "../features/ChatBot/allowedChatUsers";
import BottomNavBar from "../components/BottomNavBar/BottomNavBar";
import BottomNavBarMobile from '../components/BottomNavBar/BottomNavBarMobile';
import BottomNavBarTab from '../components/BottomNavBar/BottamNavBarTab'

const MainLayout = (props) => {
  const { theme } = useThemes();
  useZoomWarningPopup();
  // const { setDesktopView, desktopView } = useDesktopViewportScaler()
  const { sidebarDisplay } = useSelector((state) => state.sidebarReducer);
  const userDetails = useSelector((state) => state.userDetailsReducer?.userDetails);
  const canUseChat = isAllowedChatUser(userDetails?.email);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const matches = useMediaQuery('(max-width: 600px)');
  const isTabMatches = useMediaQuery('(max-width: 1200px)')
  const sideBar =
    matches === true ? (
      // <SidebarDrawer
      //   sidebarOpen={sidebarOpen}
      //   setSidebarOpen={setSidebarOpen}
      // />
       <BottomNavBarMobile/>
    ) : isTabMatches ? <BottomNavBarTab/> : (
      // sidebarDisplay && <Sidebar />
      sidebarDisplay && <BottomNavBar/>
    );

  return (
    <Box
      sx={{
        minHeight: "100%",
        background: theme.palette.bodyGray.main,
      }}
    >
      {/* <SideNavButtons/> */}

      {/* {
        matches && <FullscreenButton matches = {false}/>
      } */}
      {/* rgb(248 255 255 / 50%) */}
      {sidebarDisplay && (
        // && props.nav === true
        <Navbar
          matches={matches}
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />
      )}
      {sideBar}
      <Box
        sx={{
          margin: {
            xs: "0px 10px 10vh 10px",
            sm: "0px 10px 7vh 10px",
            lg: "0px 30px 0px 35px",
          },
          paddingTop: { xs: "60px", sm: "80px" },
        }}
      >
        {/* <ZoomWarningPopup /> */}
        <LayoutAlerts />
            {/* <button onClick={(e) => {
        e.preventDefault();
        setDesktopView((prev) => !prev)}}>Click {desktopView ? 1 : 0}</button> */}
        {props.children}
        
        <LogoutSpinner />
      </Box>
     
      {/* Floating Chat Widget (beta: only allowed users) */}
      { <FloatingChatWidget isProd = {canUseChat}/>}
    </Box>
    
  );
};

export default MainLayout;
